module.exports = __webpack_public_path__ + "img/map-dashboard-icon.149f9e4.png";